import XButton from '../common/XButton';
import useMedicalProvidersInputMode from '../../hooks/useMedicalProvidersInputMode';
import RenderIf from '../render-if/Renderif';

const ProviderModeToggleButton = ({ isPostAccident }) => {
    const { isAiMode, toggleMode, isToggleAvailiable } = useMedicalProvidersInputMode(isPostAccident);

    return (
        <RenderIf shouldRender={isToggleAvailiable}>
            <XButton
                variant="outlinePrimary"
                size="sm"
                onClick={toggleMode}
                buttonText={isAiMode ? 'Manually Enter Providers' : 'Use AI'}
            />
        </RenderIf>
    );
};

export default ProviderModeToggleButton;
